import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Ciudadano = {
  id: number;
  nombre: string;
  apellido: string;
  email: string;
  municipio_id: number;
  municipio_nombre?: string;
  latitud?: string | null;
  longitud?: string | null;
  identidad_verificada?: number | boolean;
};

type AuthStore = {
  accessToken: string | null;
  refreshToken: string | null;
  ciudadano: Ciudadano | null;
  setSession: (access: string, refresh: string, ciudadano: Ciudadano) => void;
  setCiudadano: (ciudadano: Ciudadano) => void;
  logout: () => void;
};

export const useAuth = create<AuthStore>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      ciudadano: null,
      setSession: (access, refresh, ciudadano) =>
        set({ accessToken: access, refreshToken: refresh, ciudadano }),
      setCiudadano: (ciudadano) => set({ ciudadano }),
      logout: () => set({ accessToken: null, refreshToken: null, ciudadano: null }),
    }),
    { name: 'ciudadapp-auth' }
  )
);
